import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Line } from 'react-chartjs-2';
import { SnaphotApi as SnaphotApiDev } from '../services/catesservices/api';
import { SnaphotApi as SnaphotApiProd } from '../services/catesservicesprod/api';
import { formatNumber } from "../components/_Helper/formatNumber";
import moment from "moment";
import 'chart.js/auto';
import 'chartjs-adapter-date-fns';
import logo from "../assets/images/rasyonet-line.png";

function Snapshot() {
  const snaphotApi = new SnaphotApiDev({
    username: 'cates-crow',
    password: 'nCY6PVfJ*AgtQr+'
  });

  const snaphotProdApi = new SnaphotApiProd({
    username: 'cates-crow',
    password: 'nCY6PVfJ*AgtQr+'
  });

  //#region Page Property
  const { t, i18n } = useTranslation();
  const chartRef = useRef();
  //#endregion

  //#region UseState
  const [maxDate, setMaxDate] = useState();
  const [visible, setVisible] = useState(false);
  const [frequency, setFrequency] = useState("1y");
  const [chartStatu, setChartStatu] = useState(true);
  const [priceGridData, setPriceGridData] = useState([]);
  const [selectedLang, setSelectedLang] = useState("");
  const [companyInformation, setCompanyInformation] = useState([]);
  const [servicesControl, setServicesControl] = useState();
  const [chartData, setChartData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: '#1e22aa',
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const [chartOptions, setChartOptions] = useState();
  let api = servicesControl !== undefined && servicesControl ? snaphotProdApi : snaphotApi;
  //#endregion  



  //#region Footer 
  const footerContent = (
    <div>
      <Button
        className="o-custom-button btn btn-secondary"
        onClick={() => setVisible(false)}
      >
        <i className="fas fa-times align-middle"></i> <span>{t("Close")}</span>
      </Button>
    </div>
  );
  //#endregion

  //#region Functions
  const frequencyFunction = (e, fr) => {
    setFrequency(fr);

    let items = document.querySelectorAll("#chart-dates .list-inline-item");
    items.forEach((s) => {
      if (s.childNodes[0].classList.contains("selected")) {
        s.childNodes[0].classList.remove("selected");
      }
    });
    e.target.classList.add("selected");
  };

  const handlePage = () => {
    companyInfo();
  };
  //#endregion 

  //#region Page Load Data

  const priceChartData = () => {
    let f = "";
    if (frequency === "1w") f = "OneWeek"
    else if (frequency === "1m") f = "OneMonth"
    else if (frequency === "3m") f = "ThreeMonth"
    else if (frequency === "6m") f = "SixMonth"
    else if (frequency === "1y") f = "OneYear"
    else if (frequency === "2y") f = "TwoYear"
    else if (frequency === "3y") f = "ThreeYear"
    else if (frequency === "5y") f = "FiveYear"

    if (api !== undefined && api !== "") {
      api.apiSnaphotPriceChartGet("CATES", f)
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            let catesdata = response.data[0]["sec.101.57839"];
            let data1 = [];
            let label = [];

            for (var i = 0; i < catesdata.length; i++) {
              data1.push(catesdata[i]["value"].toFixed(2));
              label.push(moment(new Date(catesdata[i]["date"].toString().split('T')[0])).format("yyyy-MM-DD"));
            }

            const newChartData = {
              labels: label,
              datasets: [
                {
                  data: data1,
                  fill: false,
                  borderColor: '#1e22aa',
                  borderWidth: 1,
                  pointRadius: 0,
                },
              ],
            };

            let dateLabels = newChartData.labels;
            const maxDate = new Date(Math.max(...dateLabels.map(date => new Date(date))));
            const formattedDate = moment(new Date(maxDate)).format("DD.MM.YYYY")
            setMaxDate(formattedDate);
            setChartData(newChartData);
            setPriceGridData(catesdata);
          }
        })
    }
  };

  const companyInfo = () => {
    if (api !== undefined && api !== "") {
      api.apiSnaphotCardFieldsGet("sec.101.57839", selectedLang)
        .then(response => {
          if (response.status === 200) {
            let data = response.data.sort((a, b) => a.order > b.order ? 1 : -1);

            const formattedData = data.map(item => {
              if (typeof item.value === 'number' && item.value % 1 !== 0) {
                return { ...item, value: item.value.toFixed(2) };
              }
              return item;
            });

            setCompanyInformation(formattedData);
          }
        })
    }
  };

  //#endregion

  //#region UseEffect
  useEffect(() => {
    let control = typeof window.location !== 'undefined' &&
      window.location.origin.indexOf("localhost") !== -1 ?
      false :
      window.location.origin.indexOf("cates-test.rasyonet") !== -1 ?
        false :
        window.location.origin.indexOf("cates.rasyonet") !== -1 &&
        true;

    setServicesControl(control);

    if (window.location.pathname.indexOf("snapshot") !== -1) {
      i18n.changeLanguage("en");
      setSelectedLang("en-US");
    } else setSelectedLang("tr-TR");

  }, []);

  useEffect(() => {
    priceChartData();
  }, [frequency]);

  useEffect(() => {
    if (selectedLang !== "") {
      handlePage();
      setChartOptions({
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            intersect: false,
            mode: 'index',
            callbacks: {
              label: (tooltipItem) => {
                return formatNumber(tooltipItem.raw, 2, selectedLang) + " TL";
              },
              title: (tooltipItems) => {
                const date = new Date(tooltipItems[0].parsed.x);
                if (selectedLang === 'tr-TR') {
                  return new Intl.DateTimeFormat('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }).format(date);
                }
              },
            },
          },
        },
        scales: {
          x: {
            type: 'time',
            distribution: 'linear',
            grid: {
              display: false,
            },
            ticks: {
              callback: (value, index, ticks) => {
                const date = new Date(value);
                if (selectedLang === 'tr-TR') {
                  return new Intl.DateTimeFormat('tr-TR', {
                    year: 'numeric',
                    month: 'short'
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: 'short'
                  }).format(date);
                }
              },
              font: {
                color: '#000',
                size: 13,
              },
            },
            time: {
              unit: 'month'
            },
          },
          y: {
            grid: {
              color: "#E1E2E2",
            },
            ticks: {
              callback: function (value, index, ticks) {
                return formatNumber(value, 2, selectedLang);
              },
              font: {
                color: '#000',
                size: 12,
              },
              padding: 15,
            },
            beginAtZero: false,
          },
        },
      })
    }
  }, [selectedLang]);




  //#endregion

  return (
    <>
      <div className="container-fluid mt-4">
        <div className="header mb-4">{t("headerTitle")}</div>

        <div className="row mb-4">
          <div className="col-6">
            <div className="title mb-4">
              {t("pricePerformance")}
              <i
                className="fa fa-th float-end"
                onClick={() => setChartStatu(!chartStatu)}
              ></i>
            </div>
            <div className={`row ${chartStatu ? "" : "d-none"}`}>
              <div className="col-md-12 text-end rt-item">
                <ul
                  id="chart-dates"
                  className="list-inline m-0 chart-period-btn mb-3"
                >
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "1w")}
                  >
                    <Link data-date="1w" className="btn btn-block">
                      1{t("weekly")}
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "1m")}
                  >
                    <Link data-date="1m" className="btn btn-block">
                      1{t("month")}
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "3m")}
                  >
                    <Link data-date="3m" className="btn btn-block">
                      3{t("month")}
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "6m")}
                  >
                    <Link data-date="6m" className="btn btn-block">
                      6{t("month")}
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "1y")}
                  >
                    <Link data-date="1y" className="btn btn-block selected">
                      1y
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "2y")}
                  >
                    <Link data-date="2y" className="btn btn-block">
                      2y
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "3y")}
                  >
                    <Link data-date="3y" className="btn btn-block">
                      3y
                    </Link>
                  </li>
                  <li
                    className="list-inline-item"
                    onClick={(e) => frequencyFunction(e, "5y")}
                  >
                    <Link data-date="5y" className="btn btn-block">
                      5y
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="d-block chart-area">
                <div className="chart-y-axis-title">TL</div>
                <Line ref={chartRef} data={chartData} options={chartOptions} />
              </div>
            </div>
            <div className={`row ${chartStatu ? "d-none" : ""}`}>
              <div className="col-md-12">
                <div className="gridTable mb-3">
                  <table className="grid w-100">
                    <thead>
                      <tr>
                        <th>{t("date")}</th>
                        <th>{t("data")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {priceGridData?.map((item, index) => (
                        <tr key={index}>
                          <td>{moment(item.date).format("DD.MM.yyyy")}</td>
                          <td>{formatNumber(item.value, 2, selectedLang)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="title">
              {t("companyInformation")}
              <span className="date float-end spacing-0">{maxDate}</span>
            </div>
            <table className="compancyCard w-100">
              <tbody>
                {companyInformation.map((item, key) => (
                  <tr key={key}>
                    <td>{item.name}</td>
                    <td className="table-value">{item.id === "field.ticker" || item.id === "field.sector" ? item.textValue : formatNumber(item.value, 2, selectedLang)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="note text-end d-inline-block w-100">{t("note")}</div>
        <div className="note text-end d-inline-block w-100">
          {t("noteSnapshot")}
        </div>

        {selectedLang === "tr-TR" ?
          <div className="note text-end d-inline-block w-100 mb-3">
            *** Piyasa verileri <img src={logo} /> tarafından sağlanmaktadır.
          </div>

          :
          <div className="note text-end d-inline-block w-100 mb-3">
             *** The share information data is provided by <img src={logo} />
          </div>
        }
      </div>

      <Dialog
        header="Haber Detayı"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        <div id="newsModalHeader" className="mb-2"></div>
        <div id="newsModalHeaderDate" className="mb-3"></div>
        <div id="newsModalHeaderProvider"></div>

        <div className="col-md-12" id="newsModalScrollDiv">
          <div id="newsModalBody" className=""></div>
        </div>
      </Dialog>
    </>
  );
}

export default Snapshot;
